import LocalizedStrings from "react-localization";
import enTranslations from "../text_utilities/en-US.json";

const translations = {
  en: enTranslations,
};

const strings = new LocalizedStrings(translations);

export default strings;